import Immutable from 'immutable';
import moment from 'moment';
import exclusionList from '../constants/redux-logger-exclusions';

const parseImmutableState = (state) => {
  return Object.keys(state).reduce((parsedState, field) => {
    parsedState[field] = state[field] instanceof Immutable.Map || state[field] instanceof Immutable.List
      ? state[field].toJS() : state[field];

    return parsedState;
  }, {});
};

const isExclusion = type => {
  return !!exclusionList.find(exclusion => exclusion.test(type));
}

let actionNumber = 0;

export default store => next => action => {
  actionNumber++;
  if (isExclusion(action.type)) {
    return next(action);
  }

  console.group(`${actionNumber} [${moment().utc().format('hh:mm:ss')}] Action: ${action.type}`);
  console.log('%c prev state:', 'line-height: 18px; color: gray; font-weight: bold', parseImmutableState(store.getState()));
  console.log('%c action', 'line-height: 18px; color: blue; font-weight: bold', action);
  
  const result = next(action);

  console.log('%c next state:', 'line-height: 18px; color: green; font-weight: bold', parseImmutableState(store.getState()));
  console.groupEnd();

  return result;
};


// WEBPACK FOOTER //
// ./src/tools/redux-logger-middleware.js